import * as THREE from 'three'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Environment from './World/Environment.js'
import Resources from './Utils/Resources.js'
import Debug from './Utils/Debug.js'
import Input from './Input.js'
import sources from './sources.js'
import SpatialCursor from './SpatialCursor.js'
import WebUI from './WebUI.js'
import LoadingScreen from './LoadingScreen.js'
import AudioManager from './AudioManager.js'
let instance = null

export default class Experience
{
    constructor(canvas)
    {
        if (instance) {
            return instance
        }
        else {
            instance = this
        }
        // Global access
        window.experience = this

        // Options
        this.canvas = canvas

        this.isMobile = navigator.userAgentData?.mobile || /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        // Setup
        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()
        this.input = new Input()
        this.scene = new THREE.Scene()
        this.resources = new Resources(sources)
        this.audioManager = new AudioManager()
        this.loadingScreen = new LoadingScreen()
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.webUI = new WebUI()
        
        this.world = new World()
        
        // Scene Changes
        this.scene.background = new THREE.Color(0x000000) //black        

        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('Experience')
            this.debugFolder.addColor(this.scene, 'background')
                .name('background color')
                .onChange(() => {
                    console.log('background color changed')
                })
        }

        // resize event
        this.sizes.on('resize', () =>
        {
            this.resize()
        })

        // tick event
        this.time.on('tick', () =>
        {
            this.update()
        })
    }

    resize()
    {
        this.camera.resize()
        this.renderer.resize()
    }

    update()
    {
        this.camera.update()
        this.world.update()
        this.renderer.update()
    }
}